export default __webpack_public_path__ + "static/media/087-aland-islands.1e4c46c0.svg";